export const REFRESH_PAGE = {
  TRANSACTIONS: "TRANSACTIONS",
  INVOICES: "INVOICES",
  BILLS: "BILLS",
  REPORTS: "REPORTS",
} as const;

export type RefreshPage = (typeof REFRESH_PAGE)[keyof typeof REFRESH_PAGE];
